import React,{ Component } from 'react';
import {Col, Row, TabContent, TabPane, NavLink, NavItem, Nav } from "reactstrap";
import classnames from 'classnames';
import AgentGraph from "./AgentGraph"

class AgentTabs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 0
        };

        this.toggle = this.toggle.bind(this);
    }

    toggle(tab){
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    static formatSizeUnits(bytes){
        if      (bytes >= 1073741824) { bytes = (bytes / 1073741824).toFixed(2) + " GB"; }
        else if (bytes >= 1048576)    { bytes = (bytes / 1048576).toFixed(2) + " MB"; }
        else if (bytes >= 1024)       { bytes = (bytes / 1024).toFixed(2) + " KB"; }
        else if (bytes > 1)           { bytes = bytes + " bytes"; }
        else if (bytes === 1)          { bytes = bytes + " byte"; }
        else                          { bytes = "0 bytes"; }
        return bytes;
    }

    render() {
        const {timeData} = this.props;
        const agentmap = this.props.agents.agents.map((agent, i) => {
            return <TabPane key={i} tabId={i}>
                <Row>
                    <Col xs={7} xl={3}>
                        <div className="callout-2 border-info">
                            <small className="text-muted">Status:</small>
                            <br/>
                            <strong>{agent.health && agent.health}</strong>
                        </div>
                    </Col>
                    <Col xs={5} xl={2}>
                        <div className="callout-2 border-warning">
                            <small className="text-muted">Kasms:</small>
                            <br/>
                            <strong className="h4">{agent.kasms && agent.kasms}</strong>
                        </div>
                    </Col>
                    <Col xs={6} xl={3}>
                        <Row>
                            <Col xs={12} xl={6}>
                                <small className="text-muted">Total Memory:</small>
                            </Col>
                            <Col xs={12} xl={6}>
                                {agent.memory_total && AgentTabs.formatSizeUnits(agent.memory_total)}
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} xl={6}>
                                <small className="text-muted">Used Memory:</small>
                            </Col>
                            <Col xs={12} xl={6}>
                                {agent.memory_used && AgentTabs.formatSizeUnits(agent.memory_used)}
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} xl={6}>
                                <small className="text-muted">Available Memory:</small>
                            </Col>
                            <Col xs={12} xl={6}>
                                {agent.memory_free && AgentTabs.formatSizeUnits(agent.memory_free)}
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={6} xl={4}>
                        <Row>
                            <Col xs={12} xl={6}>
                                <small className="text-muted">Disk Capacity:</small>
                            </Col>
                            <Col xs={12} xl={6}>
                                {agent.disk_space && AgentTabs.formatSizeUnits(agent.disk_space)}
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} xl={6}>
                                <small className="text-muted">Used Disk Space:</small>
                            </Col>
                            <Col xs={12} xl={6}>
                                {agent.disk_space_used && AgentTabs.formatSizeUnits(agent.disk_space_used)}
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} xl={6}>
                                <small className="text-muted">Available Disk Space:</small>
                            </Col>
                            <Col xs={12} xl={6}>
                                {agent.disk_space_free && AgentTabs.formatSizeUnits(agent.disk_space_free)}
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <br/>
                <Row>
                    <Col sm="12">
                        { <AgentGraph server_id={agent.server_id} timeData={timeData}/>}
                    </Col>
                </Row>
            </TabPane>
        });

        const agentTabs = this.props.agents.agents.map((data, i) => {
            return <NavItem key={i}>
                <NavLink
                    className={classnames({ active: this.state.activeTab === i })}
                    onClick={() => {
                        this.toggle(i);
                    }}
                >
                {data.name && data.name}
                {data.health !== 'Healthy' ?
                    <span className="agent-warning" ><i className="fa fa-exclamation-triangle text-danger font-2xl" /></span>
                    : ''}
                </NavLink>
            </NavItem>
        });

        return (
            <div>
                <Nav tabs>
                    {agentTabs}
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                    {agentmap}
                </TabContent>
            </div>
        );
    }
}

export default AgentTabs;


// WEBPACK FOOTER //
// ./src/views/Reporting/ReportDashboard/ReportComponents/AgentTabs.js